import { render } from "./question-drag-drop-component.vue?vue&type=template&id=43b183ea&scoped=true&ts=true"
import script from "./question-drag-drop-component.vue?vue&type=script&lang=ts"
export * from "./question-drag-drop-component.vue?vue&type=script&lang=ts"

import "./question-drag-drop-component.vue?vue&type=style&index=0&id=43b183ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b183ea"]])

export default __exports__